
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';
import { MultiOrgFilterTAComponent } from '../multi-org-filter-ta/multi-org-filter-ta.component';
import { RoleInformationComponent } from '../role-information/role-information.component';
import { AlertComponent } from 'src/app/modules/shared/components/alert/alert.component';
import { SpinnerComponent } from 'src/app/modules/shared/components/spinner/spinner.component';
import { RoleRequestSuccessComponent } from '../role-request-success/role-request-success.component';
import { CartRole, Organization, RoleRequestPayload } from 'src/app/modules/user-profile/models/role-request.models';


@Component({
    selector: 'app-role-request-new-role',
    imports: [
    RouterModule,
    MultiOrgFilterTAComponent,
    SpinnerComponent,
    RoleRequestSuccessComponent,
    RoleInformationComponent,
    AlertComponent
],
    templateUrl: './role-request-new-role.component.html',
    styleUrls: ['./role-request-new-role.component.css']
})
export class RoleRequestNewRoleComponent {
  private roleRequestService = inject(RoleRequestService);
  private spinner = inject(NgxSpinnerService);

  rolesOnCart: CartRole[] = [];
  isRequestSuccess = false;
  showErrorMessage: string;

  submitRoleRequest(): void {
    const orgKey = this.roleRequestService.multiOrgFilters?.selectedOrganization?.orgKey;
    if(!orgKey && this.roleRequestService.multiOrgFilters?.selectedRoleGroup?.roleAssignGroupKey !== '4' /* No Org */) {
      this.showError('Please select an organization');
      return;
    }
    const payload: RoleRequestPayload[] = this.rolesOnCart.map((role) => ({
      personKey: +this.roleRequestService.getLoggedInPersonKey(),
      roleKey: role.roleKey,
      usageTypeKey: 0,
      assignGroupKey: +this.roleRequestService.multiOrgFilters.selectedRoleGroup.roleAssignGroupKey,
      orgKey: this.roleRequestService.multiOrgFilters.selectedOrganization?.orgKey,
      roleRequestText: role.reason || ' ',
      roleRequestTypeKey: 1,
      effectiveDate: role.effectiveDate,
    }));

    this.spinner.show('request-new-role');
    this.showErrorMessage = '';
    this.roleRequestService.roleRequestPost(payload).subscribe(
      () => {
        this.isRequestSuccess = true;
        this.spinner.hide('request-new-role');
      },
      (err) => {
        this.spinner.hide('request-new-role');
        if(err.error?.resultMessage?.length < payload?.length) {
          this.showError("Your request was partially fulfilled. "+ err.error.resultMessage);
        } else {
          this.showError(err.error.resultMessage);
        }
      }
    );
  }

  onCartChange(event: CartRole[]): void {
    this.rolesOnCart = event;
    this.showErrorMessage = '';
  }

  onOrgChange(org: Organization): void {
    this.showErrorMessage = '';
  }

  showError(message: string): void {
    this.showErrorMessage = message;
    window.scrollTo(0, 0);
  }
}
